import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    COLORS_QUERY,
    SINGLE_COLOR_QUERY,
    CREATE_COLOR_MUTATION,
    UPDATE_COLOR_MUTATION,
    DELETE_COLOR_MUTATION
} from "@/graphql/colors.js";

const state = {
    colors: []
};

const getters = {};

const mutations = {
    [types.SET_COLORS](state, colors) {
        state.colors = colors;
    },
    [types.SORT_COLORS](state) {
        state.colors.sort(function(a, b) {
            return a.node.color.toLowerCase() == b.node.color.toLowerCase()
                ? 0
                : a.node.color.toLowerCase() > b.node.color.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_COLOR](state, color) {
        var index = state.colors.findIndex(function(element) {
            return element.node.id == color.id;
        });

        const node = { node: color };

        if (index > -1) {
            state.colors.splice(index, 1, node);
        } else {
            state.colors.unshift(node);
        }
    },
    [types.DELETE_COLOR](state, color) {
        var index = state.colors.find(function(element, index) {
            if (element.id == color.id) {
                return index;
            }
        });

        if (index > -1) {
            state.colors.splice(index, 1);
        }
    }
};

const actions = {
    async fetchColors(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: COLORS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const colors = response.data.tenantColors.edges;

                    // update store
                    context.commit(types.SET_COLORS, colors);

                    // sort
                    context.commit(types.SORT_COLORS);

                    resolve(colors);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleColor(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_COLOR_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const color = JSON.parse(
                        JSON.stringify(response.data.color)
                    );

                    // update store
                    context.commit(types.UPSERT_COLOR, color);

                    // sort
                    context.commit(types.SORT_COLORS);

                    resolve(color);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createColor(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_COLOR_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const color = response.data.createColor.color;

                    // update store
                    context.commit(types.UPSERT_COLOR, color);

                    // sort
                    context.commit(types.SORT_COLORS);

                    resolve(color);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateColor(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_COLOR_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const color = response.data.updateColor.color;

                    // update store
                    context.commit(types.UPSERT_COLOR, color);

                    // sort
                    context.commit(types.SORT_COLORS);

                    resolve(color);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteColor(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_COLOR_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const color = response.data.deleteColor.color;

                    // update store
                    context.commit(types.DELETE_COLOR, color);

                    resolve(color);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
